// NewPlacesUnlockBtn.js
var NewPlacesUnlockBtn = pc.createScript('newPlacesUnlockBtn');

// initialize code called once per entity
NewPlacesUnlockBtn.prototype.initialize = function () {

    this.entity.button.on('click', function (event) {

        loadScene(`Menu`, { hierarchy: true, settings: true }, () => {
            PlaceManager.instance.initPlace();
            let placesUI = this.app.root.findByTag("PlacesMenu")[0];
            placesUI.enabled = true;
        });

    }, this);
};



